export default __webpack_public_path__ + "static/media/Rplot01 2.6a6419fb.svg";